export const Roles = {
  Admin: 0,
  Student: 1,
  SchoolBookManager: 2,
  SchoolManager: 3,
  IddinkSchoolManager: 4,
  IddinkEmployee: 5,
  IddinkUserManager: 6,
};

export const getRole = (role) => {
  return Object.values(Roles).find((key) => Roles[key] === role) || null;
};

export const getRoleName = (value) => {
  for (const [key, val] of Object.entries(Roles)) {
    if (val === value) {
      return key;
    }
  }
  return null;
};
